<h2 mat-dialog-title>Select A Goal</h2>

<mat-dialog-content>
    <div *ngIf="selectedGoal" class="selected-goal page-description-section">
        <h3>Selected Goal: {{selectedGoal.objective}}</h3>
    </div>

    <app-data-grid-comp
        [tableId]="db_tables.EmployeeGoals"
        [columns]="columns"
        [filterCategories]="filterCategories"
        [view]="view"
        [gridDataResult]="gridDataResult"
        [isLoading]="isLoading"
        [pageSize]="pageSize"
        [skip]="skip"
        [rowSelectionSettings]="{
            canSelectRows: true,
            selectRowBy: 'id',
            showDeleteAllButton: false,
            selectableMode: 'single'
        }"
        searchable="true"
        hideActionButtons="true"
        [sortable]="{
            mode: 'multiple'
        }"
        [sortableColumns]="sortableColumns"
        (emitSortEvent)="sortChange($event)"
        [isLoading]="isLoading"
        [clearSelectedItems]="clearSelectedItems"
        (emitPageChangeEvent)="pageChange($event)"
        (emitDeleteEvent)="deleteGoals($event)"
        (emitSearchEvent)="search($event)"
        (emitFilterEvent)="filterCallback($event)"
        (emitSortEvent)="sortChange($event)"
        (emitSelectedRows)="selectedRowsChanged($event)"
    ></app-data-grid-comp>
    
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">Close</button>
    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()" [disabled]="!selectedGoal">Save</button>
</mat-dialog-actions>